export interface PromotionImageItem {
  id: string;
  promotionId?: string;
  imageId: string;
  displayOrder: number;
  url?: string | null;
  fileName?: string | null;
}

export interface PromotionProps {
  id: string;
  name: string;
  title: string;
  description?: string | null;
  imageId?: string | null;
  imageUrl?: string | null;
  imageFileName?: string | null;
  startAt: string;
  endAt: string;
  status?: boolean;
  displayOrder?: number;
  productIds?: string[];
  images?: PromotionImageItem[];
  createdAt?: string;
  updatedAt?: string;
  isCurrentlyActive?: boolean;
}

export class PromotionEntity {
  constructor(private readonly props: PromotionProps) {
    if (!props.id) throw new Error('El ID de la promoción es obligatorio');
    if (!props.name) throw new Error('El nombre de la promoción es obligatorio');
    if (!props.title) throw new Error('El título de la promoción es obligatorio');
    if (!props.startAt) throw new Error('La fecha de inicio de la promoción es obligatoria');
    if (!props.endAt) throw new Error('La fecha de término de la promoción es obligatoria');
  }

  get id(): string {
    return this.props.id;
  }

  get name(): string {
    return this.props.name;
  }

  get title(): string {
    return this.props.title;
  }

  get description(): string | null {
    return this.props.description ?? null;
  }

  get imageId(): string | null {
    return this.props.imageId ?? null;
  }

  get imageUrl(): string | null {
    return this.props.imageUrl ?? null;
  }

  get imageFileName(): string | null {
    return this.props.imageFileName ?? null;
  }

  get startAt(): string {
    return this.props.startAt;
  }

  get endAt(): string {
    return this.props.endAt;
  }

  get status(): boolean {
    return this.props.status ?? true;
  }

  get displayOrder(): number {
    return this.props.displayOrder ?? 0;
  }

  get productIds(): string[] {
    return this.props.productIds ? [...this.props.productIds] : [];
  }

  get images(): PromotionImageItem[] {
    return this.props.images ? [...this.props.images] : [];
  }

  get createdAt(): string | undefined {
    return this.props.createdAt;
  }

  get updatedAt(): string | undefined {
    return this.props.updatedAt;
  }

  get isCurrentlyActive(): boolean {
    if (this.props.isCurrentlyActive !== undefined) {
      return this.props.isCurrentlyActive;
    }
    if (!this.status) return false;
    const now = new Date();
    const start = new Date(this.startAt);
    const end = new Date(this.endAt);
    return now >= start && now <= end;
  }

  toJSON(): PromotionProps {
    return {
      ...this.props,
      productIds: this.productIds,
      images: this.images,
      isCurrentlyActive: this.isCurrentlyActive,
    };
  }
}
